module.exports = __webpack_public_path__ + "img/roka.d9a8edd5.jpg";